export default "__VITE_ASSET__CTeYcjMu__"